import { Component, Inject, Input, OnInit, EventEmitter,Output, OnChanges, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SortbyPipe } from '@netfoundry-ui/ui/pipes';
import { AgentService, ApiService, HealthCheckService, ShareService } from '@netfoundry-ui/shared/services';
import { NetworkV2, Provider, RegionV2, AllocatedIp, HealthCheck } from '@netfoundry-ui/shared/model';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';
import _, { cloneDeep, unset, isEmpty } from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { Location } from '@angular/common';

@Component({
    selector: 'app-health-check-modal',
    templateUrl: './health-check-modal.component.html',
    styleUrls: ['./health-check-modal.component.scss'],
    standalone: false
})
export class HealthCheckModalComponent implements OnInit {
    model: HealthCheck;
    displayedRegions: RegionV2[] = [];
    providers: Provider[] = [];

      @Input() isModal = false;
  @Input() formData: any = {};
  close: EventEmitter<any> = new EventEmitter<any>();
    hostId;
    networkControllerId;
    shares;
    networkId;
    provider = 'AWS';
    formView = 'simple';
    orgId;
    isV2;
    frontdoorId
    hostData: any;
    processing = false;
    hasAllocatedIps = false;
    providerSelected = false;
    nameError = false;
    nameErrorMessage
    shareIdError = false;
    shareIdMessage
    responseError = false;
    responseMessage
    httpVerbError = false;
    httpVerbMessage
    endpointError = false;
    endpointMessage
    timeoutError = false;
    timeoutMessage
    isEditing = false;
    @Input() entityId: string;

    errMap:  any = {};
    timeout = Date.now() + 10 * 60 * 1000; 

    saveSubject = new Subject<boolean>;
    mappingConfigUpdateSubject = new Subject<boolean>;
     formInit = false;
    // moreActions: any[] = [];
      moreActions = [
    {name: 'testHealthCheck', action: 'test', label: 'Test Health Check', callback: this.test.bind(this)},

  ];
    protected isLoading = false;
    subscription: Subscription = new Subscription();
    initData: any = {};
    @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
    public errors: any = {};
    basePath = '';
    previousRoute;
    protected usePreviousLocation = true;
    baseHref: any;
    _dataChange = false;

    constructor(
        private sortByPipe: SortbyPipe,
        private apiService: ApiService,
        private svc: HealthCheckService,
        private shareService: ShareService,
        private agentService: AgentService,
        public growlerService: GrowlerService,
        private location: Location,
        protected router?: Router,
        protected route?: ActivatedRoute,
    ) {
    this.previousRoute = router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
        this.subscription.add(
            this.route?.params?.subscribe(params => {
                const id = params['id'];
                if (isEmpty(id)) {
                    this.entityId = 'create';
                } else {
                  this.entityId = id;
                }
            })
        );
        this.subscription.add(
            router?.events.subscribe((event: any) => {
                  if (!event?.snapshot?.routeConfig?.path) {
                      return;
                  }
                  const pathSegments = event.snapshot.routeConfig.path.split('/');
                  this.basePath = pathSegments[0];
                
            })
        );
        this.initBaseHref();
    }

    ngOnInit() {

        this.subscription.add(
            this.apiService.currentTenant.subscribe((tenant) => {
                this.orgId = tenant.id;
                this.agentService.getAccountById(this.orgId).subscribe((frontdoor: any) => {
                    this.frontdoorId = frontdoor.id
                    if(frontdoor.version === 1) {
                        this.isV2 = false;
                    } else {
                        this.isV2 = true;
                    }
                    if(!this.isV2) {
                        this.shareService.getShares(this.frontdoorId, this.isV2).subscribe((data: any) => {
                            this.shares = data._embedded.shareList.filter((share: any) => share.type !== 'TCP');
                        })
                    } else {
                        this.shareService.getHttpShares(this.frontdoorId, this.isV2).then((data: any) => {
                            this.shares = data?._embedded?.httpShareList
                        })
                    }
                    if (this.entityId === 'create') {
                        this.formData = new HealthCheck();
                        this.initData = cloneDeep(this.formData);
                        this.entityUpdated();
                        return;
                    } else {
                        this.isEditing = true;
                        this.isLoading = true;
                        this.getSingleHealthCheck();
                    }
                })
            })
        );
        this.formInit = true;
    }

    onShareChange(selectedEnvZid: string): void {
        const selectedShare = this.shares.find(s => s.envZId === selectedEnvZid);
        if (selectedShare) {
            this.model.shareToken = selectedShare.name;
        } else {
            this.model.shareToken = undefined;
        }
    }

      entityUpdated() {
            if (this.formData.id) {
            }
            
            unset(this.formData, '_links');
            this.initData = cloneDeep(this.formData);
        }

              headerActionRequested(action: any) {
        switch(action.name) {
            case 'save':
                this.save();
                break;
            case 'close':
                this.closeForm();
                break;
            case 'toggle-view':
                this.formView = action.data;
                break;
            }
        }



    closeForm(refresh = true, ignoreChanges = false, data?, event?) {
      if (!ignoreChanges && this._dataChange) {
          const confirmed = confirm('You have unsaved changes. Do you want to leave this page and discard your changes or stay on this page?');
          if (!confirmed) {
              return;
          }
      }
      if (this.isModal) {
          this.closeModal(refresh, ignoreChanges);
      } else {
          this.returnToListPage();
      }
    }

    returnToListPage() {
        this.location.back()
    //   this.router?.navigateByUrl(`${this.basePath}/health-checks`);
    }

      closeModal(refresh = true, ignoreChanges = false, data?: any, event?: any): void {
        this.close.emit({refresh: refresh});
        if (event) {
            event.stopPropagation();
        }
    }

      save(event?: any) {
  this.processing = true;
  this.isLoading = true;

  
  const proms = [];

  // 1. Handle Subject logic for Editing mode
  if (this.isEditing) {
    this.saveSubject.next(true);
    const updateSubjectPromise = new Promise<boolean>((resolve) => {
      // Note: Consider taking(1) so this doesn't hang
      this.mappingConfigUpdateSubject.asObservable().subscribe((wasUpdated: boolean) => {
        resolve(wasUpdated);
      });
    });
    proms.push(updateSubjectPromise);
  } else {
    // If not editing, we push 'true' so the Promise.all logic stays consistent
    proms.push(Promise.resolve(true));
  }

  // 2. Branch between Create and Update
  // We wrap the observable in toPromise() or use a new Promise wrapper 
  // so Promise.all can actually track it.
  const httpCall = this.isEditing 
    ? this.svc.update( this.formData, this.frontdoorId,  this.formData.id, this.isV2)
    : this.svc.create(this.formData, this.frontdoorId, this.isV2 );

  const requestPromise = new Promise((resolve, reject) => {
    httpCall.subscribe({
      next: (result: any) => {
        if (this.isModal) {
          this.closeModal(true, true);
        } else {
          this.initData = this.formData;
          this.formData = result;
          this._dataChange = false;
          this.isLoading = false;
          this.returnToListPage()
        }
        resolve(true);
      },
      error: (err) => {
        this.processErrors(err);
        this.isLoading = false;
      }
    });
  });


  proms.push(requestPromise);

  // 3. Finalize
  Promise.all(proms)
    .then((results) => {
      // results[0] is the Subject, results[1] is the HTTP call
      if (results.every(res => res === true)) {
        this.returnToListPage();
        // TODO: Success message
      }
    })
    .catch(err => {
      // Handle errors here
    })
    .finally(() => {
      this.processing = false;
      this.isLoading = false;
    });
}

        processErrors(errorResponse: any) {
            const errors: string[] = errorResponse?.error?.errors || [];
            const httpVerbError = errors.find(e => e.includes('httpVerb'));
            const endpointError = errors.find(e => e.includes('endpoint'));
            const timeoutError = errors.find(e => e.includes('timeout'));
            const shareIdError = errors.find(e => e.includes('share'))
            const nameError = errors.find(e => e.includes('name'))
            const responseError = errors.find(e => e.includes('response'))
            if(httpVerbError) {
                this.httpVerbError = true;
                this.httpVerbMessage =  httpVerbError.split(':').slice(1).join(':').trim();
            }
            if(endpointError) {
                this.endpointError = true;
                this.endpointMessage =  endpointError.split(':').slice(1).join(':').trim();
            }
            if(timeoutError) {
                this.timeoutError = true;
                this.timeoutMessage =  timeoutError.split(':').slice(1).join(':').trim();
            }
            if(nameError) {
                this.nameError = true;
                this.nameErrorMessage =  nameError.split(':').slice(1).join(':').trim();
            }
            if(shareIdError) {
                this.shareIdError = true;
                this.shareIdMessage =  shareIdError.split(':').slice(1).join(':').trim();
            }
            if(responseError) {
                this.responseError = true;
                this.responseMessage =  responseError.split(':').slice(1).join(':').trim();
            }
            else {
                this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'Health check save request failed',
                            'Health check save request has failed.'
                    )
            );
            }
            
}


    initBaseHref() {
        try {
            const base = document?.querySelector('base');
            this.baseHref = base ? base.getAttribute('href') : '/';
        } catch (error) {
            this.baseHref = '/';
        }
    }
    getSingleHealthCheck() {
    return this.svc.getSingleHealthCheck(this.frontdoorId, this.entityId, this.isV2).subscribe({
      next: (entity: HealthCheck) => {
        this.formData = entity;
        this.initData = cloneDeep(this.formData);
        this.entityUpdated();
        this.isLoading = false;
      },
      error: (err) => {
        this.growlerService.show(
        new GrowlerData(
            'error',
            'Error',
            'Error retrieving health check data.',
        )
    );
      }
    }) 
    }

    test() {
        this.svc.execute(this.formData, this.frontdoorId, this.isV2).subscribe((data: any) => {
            if(data.error) {
            this.growlerService.show(
                    new GrowlerData(
                        'error',
                        'Error',
                        'Health Check test unsuccessful',
                        data.error
                    )
                );
            } else {
            this.growlerService.show(
                    new GrowlerData(
                        'success',
                        'Success',
                        'Health Check test successful',
                    )
                );
            }
            },
            (httpErrorResponse) => {
                this.growlerService.show(
                    new GrowlerData('error', 'Health Check test request failed. ', httpErrorResponse.error.errors[0])
                );
            }  
        )
    }

    /**
     * True when this form is showing an existing entity. Derived from the route/input
     * rather than the loaded record, so the header title doesn't briefly read
     * "Create New ..." while the record is still being fetched.
     */
    get isExistingEntity(): boolean {
        return !isEmpty(this.formData?.id) || (!isEmpty(this.entityId) && this.entityId !== 'create');
    }

}
